import styled from "styled-components";

import { TextInput } from "../../../TextField";

export const DateInput = styled(TextInput).attrs({ type: "date" })`
  text-transform: uppercase;
`;
